import React from 'react';
import { NavLink } from 'react-router-dom';
import { GlobalGA4Status } from './GlobalGA4Status';
import { WakeAlerts } from './WakeAlerts';
import { LayoutDashboard, FolderKanban } from 'lucide-react';

const topItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', testId: 'topbar-dashboard-link' },
  { to: '/projects', icon: FolderKanban, label: 'Todos os projetos', testId: 'topbar-all-projects-link' },
];

export const Topbar = () => {
  return (
    <div className="topbar" data-testid="topbar">
      <div className="flex items-center justify-between w-full gap-4">
        {/* Left side - system-level navigation (Dashboard / All projects) */}
        <nav className="flex items-center gap-1">
          {topItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `
                inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md
                transition-colors duration-150
                ${isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-muted-foreground hover:text-primary hover:bg-primary/5'}
              `}
              data-testid={item.testId}
            >
              <item.icon className="h-4 w-4" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Right side - Wake alerts + Global GA4 Status */}
        <div className="flex items-center gap-3">
          <WakeAlerts />
          <GlobalGA4Status />
        </div>
      </div>
    </div>
  );
};
